export default {

	scrollThreshold: 300,
	selectors: {
		nav: 'header.header > nav.menu--fixed',
		navLink: 'header.header > nav a',
		headerAnchor: '.js-header-anchor',
		accountMenu: '.account-menu',
	},
	headerHeight: 102,
	offsetTop: 0,
	lastScrollTop: 0,

	init() {
		this.scrollDown = this.scrollDown.bind(this);
		document.querySelector('.js-menu').addEventListener('click', (event) => {
			event.currentTarget.classList.toggle('is-active');
			document.querySelector('.menu').classList.toggle('in');
		});

		const anchor = document.querySelector(this.selectors.headerAnchor);
		if (anchor) {
			const bounds = anchor.getBoundingClientRect();
			this.offsetTop = window.scrollY + bounds.top;
		}

		this.checkScrollAmount();
		window.addEventListener('scroll', () => this.checkScrollAmount());

		Array.from(document.querySelectorAll(this.selectors.navLink)).forEach((link) => {
			link.addEventListener('click', () => {
				document.querySelector('.menu').classList.remove('in');
				document.querySelector('.js-menu').classList.remove('is-active');
			});
		});

		// document.querySelector(`${this.selectors.accountMenu} a`).addEventListener('click', (event) => {
		// 	event.preventDefault();
		// 	event.currentTarget.closest(this.selectors.accountMenu).classList.toggle('account-menu--active');
		// });
	},

	checkScrollAmount() {
		const nav = document.querySelector(this.selectors.nav);
		if (!nav) {
			return;
		}
		nav.classList.toggle('scrolled', window.scrollY > this.scrollThreshold);
		if (!document.querySelector('.menu').classList.contains('in')) {
			document.querySelector(this.selectors.nav).classList.toggle('hide', this.scrollDown() && window.scrollY > this.scrollThreshold);
		}

		if (window.scrollY > this.offsetTop) {
			document.querySelector(this.selectors.nav).style.position = 'fixed';
			document.querySelector(this.selectors.headerAnchor).style.paddingTop = `${this.headerHeight}px`;
		} else {
			document.querySelector(this.selectors.nav).style.position = 'relative';
			document.querySelector(this.selectors.headerAnchor).style.paddingTop = 0;
		}

		// if (this.scrollDown) {
		// 	document.querySelector(this.selectors.accountMenu).classList.remove('account-menu--active');
		// }
	},

	scrollDown() {
		const st = window.pageYOffset || document.documentElement.scrollTop;
		const down = st > this.lastScrollTop;
		this.lastScrollTop = st <= 0 ? 0 : st;
		return down;
	},

};
